const SET_LEVELS = (state, payload) => {
  state.levels = payload;
}

export {
  SET_LEVELS,
}